import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
// Translations load before the first render (i18n/index.ts).
import './i18n'
import { captureReferralFromUrl } from './lib/referral'

import { installAuthFetch } from './lib/authFetch'
import { startPostHog } from './lib/posthog'

// A ?ref= referral link is remembered before anything else can change the URL.
captureReferralFromUrl();

// Our own /api requests carry the Clerk session token (lib/authFetch.ts).
installAuthFetch(import.meta.env.VITE_API_URL || '');

/*
 * A tab left open across a deploy asks for a page chunk that the new build no
 * longer has (2026-10-20, pages load on demand again). Reload once onto the
 * new build rather than show a broken page; a second failure within a minute
 * is a real outage and is left to the error boundary, so this never loops.
 */
window.addEventListener('vite:preloadError', (event) => {
  try {
    const last = Number(sessionStorage.getItem('copyfi.chunkReloadAt') || 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem('copyfi.chunkReloadAt', String(Date.now()));
  } catch {
    /* storage refused: reload anyway, once per page load is still bounded */
  }
  event.preventDefault();
  window.location.reload();
});

// Force dark mode for trading platform
document.documentElement.classList.add('dark');

console.log('Mounting React App...');
const rootElement = document.getElementById("root");
console.log('Root element:', rootElement);

if (!rootElement) {
    console.error('Failed to find root element');
} else {
    try {
        const root = createRoot(rootElement);
        root.render(<App />);
        void startPostHog(); // after the first render: never delays the app
        console.log('React rendered');
    } catch (error) {
        console.error('Error rendering React app:', error);
    }
}
